import { Card, Container, Col, Row, Stack } from 'react-bootstrap'
import { RatingBar } from '../components/RatingBar'
import { BsInstagram, BsLink45Deg, BsFacebook } from 'react-icons/bs'
import { useState, useEffect } from 'react'
function FratSummary(props) {
    const [highlight, setHighlight] = useState("");

    useEffect(() => {
        if (props?.data != null) {
            const rate = parseInt(props?.data?.rating?.overall);
            if (3.5 < rate && rate <= 5) {
                setHighlight("hl-green");
            } else if (2.5 < rate && rate <= 3.5) {
                setHighlight("hl-yellow");
            } else if (1 <= rate && rate <= 2.5) {
                setHighlight("hl-red");
            } else {
                setHighlight("");
            }
        }
    }, [props.loading, props?.data?.rating?.overall]);

    if (props.loading) {
        return <div></div>;
    }
    else {
        return (
            <div>
                <Container>
                    <Row >
                        <Col className='p-0'>
                            <Card >
                                <Card.Body>
                                    <Stack direction='horizontal' gap={2} className='d-flex justify-content-center'>
                                        <h3>{props?.data?.name}</h3>
                                    </Stack>
                                    <Container>
                                        <Stack direction='horizontal' gap={5} className='justify-content-center'>
                                            <Stack direction='horizontal' gap={2} className='d-flex justify-content-center'>
                                                <h5>Overall Rating:</h5>
                                                <h5 className={highlight}>{props?.data?.rating?.overall || 'N/A'}</h5>
                                            </Stack>
                                            <Stack direction='horizontal' gap={2} className='d-flex justify-content-center'>
                                                <h5>Reputation:</h5>
                                                <h5 className='hl-info'>{props?.data?.rating?.rep}</h5>
                                            </Stack>
                                        </Stack>
                                    </Container>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {props.showInfo === 'false' ?
                        <Row className='mt-4'>
                            <Col className='p-0'>
                                <Card className='h-100'>
                                    <Card.Body className='d-flex flex-column justify-content-between pb-4'>
                                        <RatingBar title="Social Life" rating={props?.data?.rating?.social} />
                                        <RatingBar title="Brotherhood" rating={props?.data?.rating?.brother} />
                                        <RatingBar title="Friendliness" rating={props?.data?.rating?.friend} />
                                        <RatingBar title="Philanthropy" rating={props?.data?.rating?.phil} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        :
                        <Row className='mt-4'>
                            <Col style={{ paddingLeft: 0 }}>
                                <Card className='h-100'>
                                    <Card.Body className='d-flex flex-column justify-content-between pb-4'>
                                        <RatingBar title="Social Life" rating={props?.data?.rating?.social} />
                                        <RatingBar title="Brotherhood" rating={props?.data?.rating?.brother} />
                                        <RatingBar title="Friendliness" rating={props?.data?.rating?.friend} />
                                        <RatingBar title="Philanthropy" rating={props?.data?.rating?.phil} />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col style={{ paddingRight: 0 }}>
                                <Card className='h-100'>
                                    <Card.Body className='d-flex flex-column justify-content-between pb-4'>
                                        <div>
                                            <Card.Title>Information</Card.Title>
                                            <hr />
                                            {props?.data?.chapter && <Card.Text>Chapter: {props?.data?.chapter}</Card.Text>}
                                            {props?.data?.affil && <Card.Text>Affiliation: {props?.data?.affil}</Card.Text>}
                                            {props?.data?.nickname && <Card.Text>Nickname: {props?.data?.nickname}</Card.Text>}
                                            {props?.data?.address && <Card.Text style={{ marginBottom: '1rem' }}>Address: {props?.data?.address}</Card.Text>}
                                        </div>
                                        <Stack direction='horizontal' className='d-flex justify-content-center align-items-baseline' gap={4}>
                                            {props?.data?.insta && <Card.Text style={{ marginBottom: 0 }}><BsInstagram /> <a href={props?.data?.insta}>Instagram</a></Card.Text>}
                                            {props?.data?.fb && <Card.Text style={{ marginBottom: 0 }}><BsFacebook /> <a href={props?.data?.fb}>Facebook</a></Card.Text>}
                                            {props?.data?.website && <Card.Text style={{ marginBottom: 0 }}><BsLink45Deg /> <a href={props?.data?.website}>Website</a></Card.Text>}
                                        </Stack>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Container>
            </div>
        );
    }
}

export { FratSummary };